package one.healthium.paywall.ui.scheduler

import one.healthium.base.preferences.AppPreferences
import one.healthium.domain.paywall.models.RemarketingOffer
import one.healthium.domain.user.UserInteractor
import one.healthium.domain.user.models.UserProfileModel
import one.healthium.domain.user.models.bindPlaceholderValues

class RemarketingManager(
    private val remarketingScheduler: RemarketingScheduler,
    private val userInteractor: UserInteractor,
    private val appPreferences: AppPreferences,
) {
    suspend fun schedule(offers: List<RemarketingOffer>) {
        // reschedule logic is placed in platform code
        val user = userInteractor.getUser().profile
        val updatedOffers = offers.bindUserData(user, appPreferences.isMetric)
        remarketingScheduler.schedule(updatedOffers)
        appPreferences.remarketingActive = true
    }

    fun cancelAll() {
        remarketingScheduler.cancelAll()
    }

    private suspend fun List<RemarketingOffer>.bindUserData(user: UserProfileModel, isMetric: Boolean): List<RemarketingOffer> {
        return this.map { offer ->
            val updatedTitle = user.bindPlaceholderValues(offer.notification.title, isMetric)
            if (updatedTitle != offer.notification.title) {
                offer.copy(notification = offer.notification.copy(title = updatedTitle))
            } else {
                offer
            }
        }
    }
}